import IconCopy from "app/components/shared/app/icons/IconCopy";
import { copyToClipboard } from "app/lib/utils/adaya/AdayaUtils";
import ReactJsonViewer from "app/lib/utils/ReactJsonViewer";
import moment from "moment";
import React from "react";
import ContentPanel from "../shared/ContentPanel";

const TasksDetails = ({ _id, status, runAt, name, data, created, completed, Error }) => {

    return (
        <div style={{ textAlign: "left", width: '100%', marginTop: '16px' }}>
            <ContentPanel dividerOrientation="left" title="Task Info">
                <table className="script-result-details-table" border={1}>
                    <tr>
                        <td className="td-bold">Task ID</td>
                        <td><div className="td-display-flex"><div>{_id}</div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(_id)} /></div></td>
                        <td className="td-bold">Status</td>
                        <td>{status ? <div className="td-display-flex"><div>{status}</div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(status)} /></div> : ""}</td>
                    </tr>
                    <tr>
                        <td className="td-bold">Run At</td>
                        <td>{runAt ? moment(runAt).format('M/D/YYYY @ H:M:SS A') : "-"}</td>
                        <td className="td-bold">data</td>
                        <td>{data ? <div className="td-display-flex"><div><ReactJsonViewer src={data} height={"200px"} /></div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(data)} /></div> : ""}</td>
                    </tr>
                    <tr>
                        <td className="td-bold">Error</td>
                        <td><div className="td-display-flex"><div>{Error}</div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(Error)} /></div></td>
                        <td className="td-bold">Name</td>
                        <td className="td-display-column">
                            {name ? <div className="td-display-flex"><div>{name}</div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(name)} /></div> : "-"}
                        </td>
                    </tr>
                    <tr>
                        <td className="td-bold">Created At</td>
                        <td>{created ? moment(created).format('M/D/YYYY @ H:M:SS A') : "-"}</td>
                        <td className="td-bold">completed</td>
                        <td><div className="td-display-flex"><div>{completed} (UTC)</div><IconCopy style={{ color: "#1e3e08" }} onClick={() => copyToClipboard(completed)} /></div></td>
                    </tr>
                </table>
            </ContentPanel>
        </div>
    )
}

export default TasksDetails;